const getColumnListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
  paddingBottom: 80,
  display: 'flex',
  overflow: 'auto',
  width: '100%',
});

export default getColumnListStyle;
